// ══════════════════════════════════════════════════════════
// DEFINICIÓN DE LAS 8 ARENAS
// ══════════════════════════════════════════════════════════

export interface ArenaDefinition {
  id: string;
  name: string;
  description: string;
  shape: 'circle' | 'octagon' | 'rectangle';
  friction: number;       // multiplicador de fricción del suelo
  specialEffect: string;  // descripción del efecto especial
  hasObstacles: boolean;
  rotating: boolean;
}

export const ARENAS: ArenaDefinition[] = [
  {
    id: 'clasica',
    name: '🌀 Clásica',
    description: 'La arena de toda la vida. Sin efectos, combate puro.',
    shape: 'circle',
    friction: 1.0,
    specialEffect: 'Ninguno.',
    hasObstacles: false,
    rotating: false,
  },
  {
    id: 'hielo',
    name: '❄️ Hielo',
    description: 'Suelo resbaladizo. Las peonzas se deslizan más.',
    shape: 'circle',
    friction: 0.3,
    specialEffect: 'Fricción reducida (0.3x). Partículas de hielo.',
    hasObstacles: false,
    rotating: false,
  },
  {
    id: 'lava',
    name: '🌋 Lava',
    description: '¡Cuidado! Los bordes queman.',
    shape: 'circle',
    friction: 1.0,
    specialEffect: 'Daño 2 HP/s por contacto con el borde.',
    hasObstacles: false,
    rotating: false,
  },
  {
    id: 'electro',
    name: '⚡ Electro',
    description: 'Zonas electromagnéticas cambiantes.',
    shape: 'octagon',
    friction: 1.0,
    specialEffect: 'Zonas electro atraen/repelen alternando cada 8s.',
    hasObstacles: false,
    rotating: false,
  },
  {
    id: 'laberinto',
    name: '🏗️ Laberinto',
    description: 'Obstáculos internos para rebotar.',
    shape: 'rectangle',
    friction: 1.0,
    specialEffect: '3-5 obstáculos redondeados estáticos.',
    hasObstacles: true,
    rotating: false,
  },
  {
    id: 'ventosa',
    name: '💨 Ventosa',
    description: 'Succión gradual hacia el centro.',
    shape: 'circle',
    friction: 1.0,
    specialEffect: 'Fuerza radial hacia el centro (0.2 px/frame).',
    hasObstacles: false,
    rotating: false,
  },
  {
    id: 'diana',
    name: '🎯 Diana',
    description: 'Zonas de puntuación en el suelo.',
    shape: 'circle',
    friction: 1.0,
    specialEffect: 'Anillos concéntricos: centro 3x, medio 2x, exterior 1x puntos.',
    hasObstacles: false,
    rotating: false,
  },
  {
    id: 'giratoria',
    name: '🔄 Giratoria',
    description: 'La arena rota arrastrando las peonzas.',
    shape: 'circle',
    friction: 1.0,
    specialEffect: 'La arena rota 0.5 rad/s. Arrastra peonzas tangencialmente.',
    hasObstacles: false,
    rotating: true,
  },
];
